export default __webpack_public_path__ + "static/media/ColorCars_05.e902db87.png";